<template>
  <v-dialog
    @click:outside="clickOutside"
    :scrollable="false"
    v-if="isShowDialog"
    v-model="isShowDialog"
    content-class="elevation-0"
  >
    <slot v-if="isShowDialog" class="on-boarding-dialog__slot" />
    <div
      v-for="(window) in preparedWindow"
      :key="window.key"
      class="on-boarding-dialog"
      :class="getCustomClasses(window)"
      :style="{
        left: `${window.left}px`, top: `${window.top}px`, right: `${window.right}px`, bottom: `${window.bottom}px`,
      }"
    >
      <button
        type="button"
        class="on-boarding-dialog__close-button"
        title="Закрыть окно"
        aria-label="Закрыть подсказку"
        @click="hideScreen(window)" />
      <p class="on-boarding-dialog__text">{{window.message}}</p>
      <button
        v-if="window.hasNextButton"
        class="on-boarding-dialog__next-button"
        type="button"
        @click="hideScreen(window)"
      >Далее</button>
    </div>
  </v-dialog>
</template>

<script>
import onBoardingShowMixin from '@/mixins/onBoardingShowMixin';
import mobileMixin from '@/mixins/mobileMixin';

export default {
  props: {
    supportsWindows: {
      type: Object,
      required: false,
      default() {
        return {
          cabinetCreateButton: {
            contentClass: 'cabinet-create',
            modifClass: 'bottom-arrow',
            key: 'cabinet-button-create',
            slugStep: 'create-addition-place',
            message: 'Нажмите кнопку, чтобы добавить кресло согласно вашему тарифу',
            hasNextButton: true,
          },
          cabinetNextButton: {
            contentClass: 'cabinet-next',
            modifClass: 'bottom-arrow',
            key: 'cabinet-button-next',
            slugStep: 'create-addition-place',
            message: 'Продолжите заполнять настройки',
            hasNextButton: false,
          },
          roleCreateButton: {
            contentClass: 'role-create',
            modifClass: 'bottom-arrow',
            key: 'role-button-create',
            slugStep: 'meet-with-allowed-roles',
            message: 'Нажмите кнопку, чтобы создать дополнительную роль',
            hasNextButton: false,
          },
          employerCreateButton: {
            contentClass: 'employer-create',
            modifClass: 'bottom-arrow',
            key: 'employer-button-create',
            slugStep: 'insert-data-about-employers',
            message: 'Нажмите кнопку, чтобы создать сотрудника',
            hasNextButton: true,
          },
          employerEditButton: {
            contentClass: 'employer-edit',
            modifClass: 'right-arrow',
            key: 'employer-button-edit',
            slugStep: 'insert-data-about-employers',
            message: 'Перейдите в режим редактирования для настройки схемы расчета ЗП',
            hasNextButton: false,
          },
          scheduleViewEditModeButton: {
            contentClass: 'schedule-view-edit-mode',
            modifClass: 'left-arrow',
            key: 'select-view-schedule-mode',
            slugStep: 'view-schedule',
            message: 'Выберите режим отображения цвета в расписании',
            hasNextButton: true,
          },
          scheduleViewEditTheColorButton: {
            contentClass: 'schedule-view-edit-the-color',
            modifClass: 'right-arrow',
            key: 'select-the-color',
            slugStep: 'view-schedule',
            message: 'Установите цвет',
            hasNextButton: false,
          },
          scheduleEditModeClinicButton: {
            contentClass: 'schedule-clinic-mode-edit',
            modifClass: 'left-arrow',
            key: 'schedule-button-clinic-mode-edit',
            slugStep: 'insert-schedule-work',
            message: 'Задайте график работы клиники',
            hasNextButton: true,
          },
          scheduleEditTimeClinicButton: {
            contentClass: 'schedule-clinic-time-edit',
            modifClass: 'left-arrow',
            key: 'schedule-button-clinic-time-edit',
            slugStep: 'insert-schedule-work',
            message: 'Укажите время работы клиники',
            hasNextButton: true,
          },
          scheduleEditModeDoctorButton: {
            contentClass: 'schedule-doctor-mode-edit',
            modifClass: 'left-arrow',
            key: 'schedule-button-doctor-mode-edit',
            slugStep: 'insert-schedule-work',
            message: 'Задайте график работы сотрудника и укажите ассистента',
            hasNextButton: true,
          },
          priceListCreatingFunctionButtons: {
            contentClass: 'price-list-creating-function',
            modifClass: 'bottom-arrow',
            key: 'price-list-button-creating-function',
            slugStep: 'insert-price-in-price-list',
            message: 'Нажмите, чтобы добавить новую категорию или услугу',
            hasNextButton: true,
          },
          priceListEditPriceButton: {
            contentClass: 'price-list-price-edit',
            modifClass: 'bottom-arrow',
            key: 'price-list-button-price-edit',
            slugStep: 'insert-price-in-price-list',
            message: 'Нажмите, чтобы задать стоимость',
            hasNextButton: false,
          },
        };
      },
    },
    /**
     * Готова ли страница к показу ОнБординг диалога
     *
     * @type {boolean}
     */
    isPageReady: {
      type: Boolean,
      required: false,
      default() { return true; },
    },
    /**
     * Флаг месседжа для кнопки "Создать кресло"
     * в разделе "Кресла".
     *
     * @type Boolean
     */
    isShowButtonCreateCabinet: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Далее"
     * в разделе "Кресла".
     *
     * @type Boolean
     */
    isShowButtonNextCabinet: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Создать роль"
     * в разделе "роли".
     *
     * @type Boolean
     */
    isShowButtonCreateRole: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Создать сотрудника"
     * в разделе "Сотрудники".
     *
     * @type Boolean
     */
    isShowButtonCreateEmployer: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Изменить сотрудника"
     * в разделе "Сотрудники".
     *
     * @type Boolean
     */
    isShowButtonEditEmployer: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Изменить режим работы клиники"
     * в разделе "Графики".
     *
     * @type Boolean
     */
    isShowButtonEditModeClinicSchedule: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Изменить график работы клиники"
     * в разделе "Графики".
     *
     * @type Boolean
     */
    isShowButtonEditTimeClinicSchedule: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Изменить режим работы врача"
     * в разделе "Графики".
     *
     * @type Boolean
     */
    isShowButtonEditModeDoctorSchedule: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Изменить цену услуги"
     * в разделе "Цены услуг"
     *
     * @type Boolean
     */
    isShowButtonEditPricePriceList: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопок "Создать услугу и категорию"
     * в разделе "Цены услуг"
     *
     * @type Boolean
     */
    isShowButtonsCreatingFunctionsPriceList: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Выбрать режим отображения окраски"
     * в разделе "Расписание"
     *
     * @type Boolean
     */
    isShowButtonScheduleViewSelectMode: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
    /**
     * Флаг месседжа для кнопки "Выбрать цвет"
     * в разделе "Расписание"
     *
     * @type Boolean
     */
    isShowButtonScheduleViewSelectTheColor: {
      type: Boolean,
      required: false,
      default() { return false; },
    },
  },
  computed: {
    /**
     * Показывать ли окно.
     *
     * @return {boolean}
     */
    isShowDialog() {
      return (this.isShowButtonCreateCabinet
        || this.isShowButtonCreateRole
        || this.isShowButtonCreateEmployer
        || this.isShowButtonEditEmployer
        || this.isShowButtonNextCabinet
        || this.isShowButtonEditTimeClinicSchedule
        || this.isShowButtonsCreatingFunctionsPriceList
        || this.isShowButtonEditPricePriceList
        || this.isShowButtonEditModeClinicSchedule
        || this.isShowButtonEditModeDoctorSchedule
        || this.isShowButtonScheduleViewSelectMode
        || this.isShowButtonScheduleViewSelectTheColor)
        && this.isPageReady && !this.isMobile;
    },
  },
  data() {
    return {
      /**
       * Подготовленное окно месседжа
       * @type {array}
       */
      preparedWindow: [],
      isShownDialog: false,
    };
  },
  updated() {
    this.updateScreen();
  },
  methods: {
    /**
     * Получить пользовательский набор классов
     *
     * @param window {object}
     * @return {Array}
     */
    getCustomClasses(window) {
      return [window.contentClass, `on-boarding-dialog--${window.modifClass}`];
    },
    /**
     * Обновляем экран онБординга.
     * В зависимости от того какой флаг передаётся в компонент -
     * тот месседж и влючаем.
     *
     * @return {void}
     */
    updateScreen() {
      if (this.isShowButtonCreateCabinet) {
        this.pushInPreparedArray(this.supportsWindows.cabinetCreateButton);
        return;
      }
      if (this.isShowButtonNextCabinet) {
        this.pushInPreparedArray(this.supportsWindows.cabinetNextButton);
        return;
      }
      if (this.isShowButtonCreateRole) {
        this.pushInPreparedArray(this.supportsWindows.roleCreateButton);
        return;
      }
      if (this.isShowButtonCreateEmployer) {
        this.pushInPreparedArray(this.supportsWindows.employerCreateButton);
        return;
      }
      if (this.isShowButtonEditEmployer) {
        this.pushInPreparedArray(this.supportsWindows.employerEditButton);
        return;
      }
      if (this.isShowButtonEditModeClinicSchedule) {
        this.pushInPreparedArray(this.supportsWindows.scheduleEditModeClinicButton);
        return;
      }
      if (this.isShowButtonEditTimeClinicSchedule) {
        this.pushInPreparedArray(this.supportsWindows.scheduleEditTimeClinicButton);
        return;
      }
      if (this.isShowButtonEditModeDoctorSchedule) {
        this.pushInPreparedArray(this.supportsWindows.scheduleEditModeDoctorButton);
        return;
      }
      if (this.isShowButtonEditPricePriceList) {
        this.pushInPreparedArray(this.supportsWindows.priceListEditPriceButton);
        return;
      }
      if (this.isShowButtonsCreatingFunctionsPriceList) {
        this.pushInPreparedArray(this.supportsWindows.priceListCreatingFunctionButtons);
        return;
      }
      if (this.isShowButtonScheduleViewSelectMode) {
        this.pushInPreparedArray(this.supportsWindows.scheduleViewEditModeButton);
        return;
      }
      if (this.isShowButtonScheduleViewSelectTheColor) {
        this.pushInPreparedArray(this.supportsWindows.scheduleViewEditTheColorButton);
      }
    },
    /**
     * Вставляем в "Подготовленное окно" окно месседж
     *
     * @param object Объект подготовленного окна.
     *
     * @return void
     */
    pushInPreparedArray(object) {
      const index = this.preparedWindow.findIndex((item) => item.key === object.key) === -1;
      if (index) {
        this.preparedWindow.push(object);
      }
    },
    /**
     * Обработка события клика по "затемнённому экрану".
     *
     * @return {void}
     */
    clickOutside() {
      const { slugStep, key } = this.preparedWindow[0];
      this.uploadShowsUser(key, slugStep);
    },
    /**
     * Очищаем "подготовленное окно".
     *
     * @return {void}
     */
    deletePreparedWindow(key) {
      this.preparedWindow = this.preparedWindow.filter((item) => item.key !== key);
    },
    /**
     * Скрываем экран
     *
     * @param window
     * @return {Promise<void>}
     */
    async hideScreen(window) {
      await this.$onBoardingGateway.setShowToUser([window.key]);
      await this.fetchSteps();
      this.$emit('showed', window.slugStep);
      this.preparedWindow = this.preparedWindow.filter((item) => item.key !== window.key);
    },
  },
  mixins: [
    mobileMixin,
    onBoardingShowMixin,
  ],
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.on-boarding-dialog {
  position: absolute;
  padding: 10px 20px 14px 20px;
  width: 292px;
  font-family: 'PT Sans', sans-serif;
  color: #ffffff;
  border-radius: 3px;
  background-color: #0489e0;
  &::before {
    position: absolute;
    border: 21px solid #ffffff;
  }
  &--top-arrow::before {
    content: '';
    left: 50%;
    top: -20px;
    border-top-width: 0;
    border-color: transparent transparent #0489e0  transparent;
    transform: translateX(-50%);
  }
  &--right-arrow::before {
    content: '';
    top: 50%;
    right: -20px;
    border-right-width: 0;
    border-color: transparent transparent transparent #0489e0;
    transform: translateY(-50%);
  }
  &--bottom-arrow::before {
    content: '';
    left: 50%;
    bottom: -20px;
    border-bottom-width: 0;
    border-color: #0489e0 transparent transparent transparent;
    transform: translateX(-50%);
  }
  &--left-arrow::before {
    content: '';
    top: 50%;
    left: -20px;
    border-left-width: 0;
    border-color: transparent #0489e0 transparent transparent;
    transform: translateY(-50%);
  }
  &:is(.cabinet-create, .role-create, .employer-create) {
    left: 122px;
    bottom: 110px;
  }
  &:is(.price-list-creating-function) {
    left: 160px;
    bottom: 110px;
  }
  &.cabinet-next {
    right: 20px;
    bottom: 100px;
    &::before {
      left: 70%;
    }
  }
  &.employer-edit {
    right: calc(15% + 50px);
    top: 240px;
  }
  &.schedule-clinic-mode-edit {
    left: 420px;
    top: 240px;
  }
  &.schedule-clinic-time-edit {
    left: 540px;
    top: 240px;
  }
  &.schedule-doctor-mode-edit {
    left: 420px;
    top: 280px;
  }
  &.schedule-view-edit-mode {
    left: 420px;
    top: 180px;
  }
  &.schedule-view-edit-the-color {
    right: 110px;
    top: 324px;
  }
  &.price-list-price-edit {
    right: 270px;
    top: 240px;
  }
  &__close-button {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 16px;
    height: 16px;
    mask: url("@/assets/img/exit-dark-grey.svg") no-repeat center;
    mask-size: 16px;
    background-color: #ffffff;
    transition: all 0.3s ease 0s;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.6;
      scale: 0.9;
    }
  }
  &__text {
    margin-block: 10px 10px;
    font-size: 16px;
    line-height: normal;
    opacity: 0.9;
  }
  &__next-button {
    @include buttons.btn-transparent(min(100%, 111px), 32px, 16px);
    gap: 6px;
    margin-top: 4px;
    margin-left: auto;
    color: #ffffff;
    line-height: 16px;
    border-color: #ffffff;
    background-color: transparent;
    &::after {
      content: '';
      width: 16px;
      height: 16px;
      background: url("@/assets/img/arrow/arrow-next-white.svg") no-repeat center;
      background-size: 16px;
      transition: all 0.3s ease 0s;
    }
    &:hover:not(:disabled) {
      color: inherit;
      border-color: inherit;
      &::after {
        transform: translateX(5px);
      }
    }
    &:active {
      opacity: 0.7;
    }
    &:disabled {
      color: var(--unfocus-color);
      background-color:inherit;
      &::after {
        content: none;
      }
    }
  }
  &__slot{
    position: absolute;
  }
}

@media screen and (max-width: 1260px) {
  .on-boarding-dialog {
    &.schedule-clinic-mode-edit {
      top: 290px;
    }
  }
}

@media screen and (max-width: 1150px) {
  .on-boarding-dialog {
    &.employer-edit {
      right: calc(10% + 50px);
    }
  }
}

@media screen and (max-width: 960px) {
  .on-boarding-dialog {
    &:is(.cabinet-create, .role-create, .employer-create, .price-list-creating-function){
      left: 10px;
    }
    &.employer-edit {
      right: 100px;
      top: 475px;
    }
    &.schedule-clinic-mode-edit {
      left: 320px;
      top: 290px;
    }
    &.schedule-doctor-mode-edit {
      left: 3320px;
      top: 320px;
    }
  }
}

@media screen and (max-width: 480px) {
  .on-boarding-dialog {
    &.employer-edit {
      left: 50%;
      top: 265px;
      transform: translateX(-50%);
      &::before {
        left: 50%;
        top: auto;
        right: auto;
        bottom: -20px;
        border-right-width: 21px;
        border-bottom-width: 0;
        border-color: #0489e0 transparent transparent transparent;
        transform: translateX(-50%);
      }
    }
  }
}

</style>
